<script lang="ts" setup>
import SancareOcticon from './SancareOcticon.vue'

withDefaults(
  defineProps<{
    octiconName: string
    isLoading?: boolean
    isDisabled?: boolean
    title?: string | null
    width?: number | null
    height?: number | null
    customClass?: string | null
  }>(),
  {
    isLoading: false,
    isDisabled: false,
    title: null,
    width: null,
    height: null,
    customClass: null,
  },
)

defineEmits(['click'])
</script>

<template>
  <span
    v-if="isLoading"
    class="loader loader-sm m-0"
  />
  <button
    v-else
    :title="title"
    class="btn-octicon"
    :class="{ 'btn-octicon--disabled': isDisabled }"
    @click="$emit('click')"
  >
    <sancare-octicon
      :name="octiconName"
      :width="width"
      :height="height"
      :class="customClass"
    />
  </button>
</template>
